import React from "react";

import { BalanceCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function balance({ width, onResize }: Column.Options) {
	return base(ColumnId.Balance, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default balance;
